$(document).ready(()=>{
  $('.go_top').on('click', () => {
    $('html,body').animate({scrollTop: 0}, 'slow');
  })
});